import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom"; // ✅ Importamos useNavigate y Link
import "../styles/productos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../img/logoAmnorte.png";
import tubored from "../img/tubo_redondo.png";

const menuItems = [
  { name: "Inicio", link: "/" },
  { name: "Nosotros", link: "/nosotros" },
  {
    name: "Productos",
    link: "/productos",
    dropdown: [
      { name: "Tubería Redonda", link: "/tuberia-redonda" },
      { name: "Tubería Redonda-Cédulas", link: "/tuberia-cedulas" },
      { name: "Tubo Cerquero", link: "/tubo-cerquero" },
      { name: "Tubería Cuadrada", link: "/tuberia-cuadrada" },
      { name: "PTR y Perfiles Rectangulares", link: "/ptr" },
      { name: "Perfiles Puerta", link: "/perfil-puerta" },
      { name: "Perfiles Ventana", link: "/perfil-ventana" },
      { name: "Ángulos y Soleras", link: "/angulos-soleras" },
      { name: "Lámina R-101", link: "/lamina-R-101" },
    ],
  },
  {
    name: "Servicios",
    link: "/servicio",
    dropdown: [
      { name: "Corte Láser", link: "/servicio#corte_laser" },
      { name: "Corte de Tubo", link: "/servicio#corte_tubo" },
      { name: "Doblez", link: "/servicio#doblez" },
      { name: "Doblez de Tubo", link: "/servicio#doblez-tubo" },
    ],
  },
  { name: "Contácto", link: "/contacto" },
];

const NavBar = () => {
  const navigate = useNavigate(); // ✅ Hook para navegación

  const [navbarColor, setNavbarColor] = useState("#354a66");

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const carouselElement = document.getElementById("main-carousel");
      const carouselHeight = carouselElement ? carouselElement.clientHeight : 500;

      if (scrollY < carouselHeight / 2) {
        setNavbarColor("#354a66");
      } else {
        setNavbarColor("#354a66");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar expand="lg" style={{ background: navbarColor, transition: "background 0.3s ease-in-out" }} fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand as={Link} to="/" style={{ color: "#fff" }}>
          <img src={logo} alt="Logo Aceros y Metales" height="50" className="me-2" />
          <span>Aceros y Metales</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarNav" />
        <Navbar.Collapse id="navbarNav">
          <Nav className="ms-auto">
            {menuItems.map((item, index) =>
              item.dropdown ? (
                <NavDropdown key={index} title={item.name} id={`dropdown-${index}`} style={{ color: "#fff" }}>
                  {/* ✅ Hacer que "Productos" sea clickeable y navegue */}
                  {item.link && (
                    <NavDropdown.Item onClick={() => navigate(item.link)} style={{ color: "#fff", fontWeight: "bold" }}>
                      {item.name}
                    </NavDropdown.Item>
                  )}
                  <NavDropdown.Divider />
                  {item.dropdown.map((subItem, subIndex) => (
                    <NavDropdown.Item key={subIndex} href={subItem.link} style={{ color: "#fff" }}>
                      {subItem.name}
                    </NavDropdown.Item>
                  ))}
                </NavDropdown>
              ) : (
                <Nav.Link as={Link} to={item.link} key={index} style={{ color: "#fff", transition: "color 0.3s ease" }}>
                  {item.name}
                </Nav.Link>
              )
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
const TuboRedondo = () => {
  return (
    <section>
      <div className="servicios-container" style={{ textAlign: "center" }}>
        <div
          className="servicios-title"
          style={{
            marginTop: "130px",
            fontSize: "3rem",
            fontWeight: "bold",
            color: "#f58634",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            padding: "10px",
            animation: "fadeIn 1s ease-in-out",
            textAlign: "center",
          }}
        >
          Tubería Redonda
        </div>
      </div>
      <div className="row" style={{ marginTop: '50px', display: 'flex', alignItems: 'center' }}>
        {/* Descripción del producto */}
        <div className="col-md-4 d-flex flex-column justify-content-center align-items-center">
          <br /><br />
          <p style={{ marginLeft: '15px', textAlign: 'justify' }}>
            El tubo redondo de acero es una barra hueca de alta calidad, ideal para una variedad de aplicaciones industriales.
            Su diseño de contorno redondo y extremos abiertos lo hace perfecto para proyectos que requieren resistencia y durabilidad.
            Un material confiable y versátil para tus proyectos.
            <br /><br />
            <img src={tubored} alt="Tubo Redondo" style={{ maxWidth: '350px', marginLeft: '30px' }} />
          </p>
        </div>

        {/* Tabla del producto */}
        <div className="col-md-8">
          {/* Contenedor con scroll para las tres tablas */}
          <div style={{ maxHeight: '70vh', overflowY: 'auto', maxWidth: '100%', margin: '0 auto' }}>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th colspan="8" className="text-center bg-orange text-white"
                    style={{ fontSize: "1.5rem", padding: "10px;", background: '#f58634' }}>
                    Tubería Redonda
                  </th>
                </tr>
                <tr>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Descripción</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Dim. Pulg.</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Calibre (nominal)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Espesor</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Inventario</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Longitud (metros)</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Piezas x Paquete</th>
                  <th style={{ background: "#ffe4b2", color: "#000" }}>Kilogramo x Metro</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: 'center' }}>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="2">1/2"</td>
                  <td rowspan="2">0.500"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>228</td>
                  <td>0.26</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>228</td>
                  <td>0.34</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="2">5/8"</td>
                  <td rowspan="2">0.625"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>216</td>
                  <td>0.34</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>228</td>
                  <td>0.44</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="4">3/4"</td>
                  <td rowspan="4">0.750"</td>
                  <td>22</td>
                  <td>0.0299</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>186</td>
                  <td>0.34</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>186</td>
                  <td>0.41</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>186</td>
                  <td>0.53</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>169</td>
                  <td>0.66</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="2">7/8"</td>
                  <td rowspan="2">0.875"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>180</td>
                  <td>0.48</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>150</td>
                  <td>0.63</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="3">1"</td>
                  <td rowspan="3">1.000"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>137</td>
                  <td>0.55</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>137</td>
                  <td>0.72</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>127</td>
                  <td>0.89</td>
                </tr>
                <tr>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="3">1 1/4"</td>
                  <td style={{ background: "#f0f0f0" }} rowspan="3">1.250"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>124</td>
                  <td>0.69</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>124</td>
                  <td>0.91</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>127</td>
                  <td>1.13</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="4">1 1/2"</td>
                  <td rowspan="4">1.500"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N / GN</td>
                  <td>6.03</td>
                  <td>95</td>
                  <td>0.84</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N / GN</td>
                  <td>6.03</td>
                  <td>97</td>
                  <td>1.10</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>91</td>
                  <td>1.37</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>14</td>
                  <td>0.0747</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>91</td>
                  <td>1.69</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="2">1 3/4"</td>
                  <td rowspan="2">1.750"</td>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>69</td>
                  <td>1.29</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>91</td>
                  <td>1.61</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td rowspan="3">2"</td>
                  <td rowspan="3">2.000"</td>
                  <td>20</td>
                  <td>0.0359</td>
                  <td>N</td>
                  <td>6.40</td>
                  <td>67</td>
                  <td>1.12</td>
                </tr>
                <tr style={{ background: "#ffe4b2" }}>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>67</td>
                  <td>1.48</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>61</td>
                  <td>1.84</td>
                </tr>
                <tr>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="2">2 1/4"</td>
                  <td style={{ background: "#f0f0f0" }} rowspan="2">2.250"</td>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>60</td>
                  <td>1.67</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>61</td>
                  <td>2.08</td>
                </tr>
                <tr>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="2">2 1/2"</td>
                  <td style={{ background: "#f0f0f0" }} rowspan="2">2.500"</td>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>60</td>
                  <td>1.86</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>61</td>
                  <td>2.32</td>
                </tr>
                <tr>
                  <td style={{ background: "#f0f0f0f7" }} rowspan="2">3"</td>
                  <td style={{ background: "#f0f0f0" }} rowspan="2">3.000"</td>
                  <td>18</td>
                  <td>0.0478</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>39</td>
                  <td>2.24</td>
                </tr>
                <tr style={{ background: "#fff" }}>
                  <td>16</td>
                  <td>0.0598</td>
                  <td>N</td>
                  <td>6.03</td>
                  <td>39</td>
                  <td>2.79</td>
                </tr>
              </tbody>
            </table>

            <ul>
              <p>Productos especiales sujetos a mínimos de fabricación. </p>
              <p>Disponibles en RF con acabado Pintado y Galvanizado.</p>
              <p>Para factibilidad en diferentes calibres, longitudes y acabados pregunte a su asesor de
                ventas.</p>
              <ul>
                <li>N-Natural.</li>
                <li>PR-Pintado Rojo</li>
                <li>GN-Galvanizado</li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

const Servicios = () => {
  return (
    <section className="nservicios text-center my-5">
      <h3>Nuestros Servicios</h3>
      <div className="servicios-container">
        <Link to='/servicio#corte_laser' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Corte Láser</p>
            <img src={require("../img/laser.png")} alt="Corte Láser" />
          </div>
        </Link>
        <Link to='/servicio#corte_tubo' style={{ textDecoration: 'none' }} >
          <div className="servicio">
            <p>Corte de Tubo</p>
            <img src={require("../img/corte_recto.png")} alt="Corte Recto" />
          </div>
        </Link>
        <Link to='/servicio#doblez' style={{ textDecoration: 'none' }}>
          <div className="servicio">
            <p>Doblez de Lámina</p>
            <img src={require("../img/dobladora-lamina.png")} alt="Doblez de Lámina" />
          </div>
        </Link>
        <Link to='/servicio#doblez-tubo' style={{textDecoration:'none'}}>
          <div className="servicio">
            <p style={{ fontSize: "13px" }}>Doblez de Tubo</p>
              <img src={require("../img/dobladora-tubo.JPG")} alt="Doblez de Tubo" />
          </div>
        </Link>

      </div>
    </section>
  );
};

const WhatsAppButton = () => (
  <a href="https://wa.me/525547829794" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
    <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "60px", height: "60px" }} />
  </a>
);

const Footer = () => (
  <footer className="footer">
    <div className="container fluid">
      <div className="row d-flex align-items-stretch">
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="contact-info text-center" style={{ textAlign: "justify" }}>
            <h5>CONTÁCTANOS</h5>
            <p style={{ color: "#fff" }}><strong>Email:</strong> contacto@aymnorte.com.mx</p>
            <p style={{ color: "#fff" }}><strong>Teléfono:</strong> +52 55 4782 9794</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CORPORATIVO</h5>
            <p>Calzada Mariano Escobedo #476,<br />Piso 12 Int. 1200 B, Anzures,<br />Miguel Hidalgo, Ciudad de México, C.P. 11590</p>
          </div>
        </div>
        <div className="col-md-4 mb-4 d-flex flex-column justify-content-center">
          <div className="address text-center" style={{ textAlign: "justify" }}>
            <h5>CEDIS</h5>
            <p>Carretera Federal México-Querétaro KM 100,<br />San Miguel de la Victoria, Jilotepec,<br />Estado de México, C.P. 54270</p>
          </div>
        </div>
      </div>
      <div className="row text-center">
        <div className="col-md-12">
          <p style={{ color: "#fff" }}>AMNorte Aceros y Metales &copy; 2025 - Todos los derechos reservados</p>
          <p>
            <Link to='/Avisos_Privacidad'>
              <a style={{ color: "white", textDecoration: "none" }}>Aviso de Privacidad |</a>
            </Link>
            <Link to='/Terminos_y_Condiciones'>
              <a style={{ color: "white", textDecoration: "none" }}> Términos y Condiciones</a>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

const Tuberia_redonda = () => {
  return (
    <div>
      <NavBar />
      <TuboRedondo />
      <Servicios />
      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default Tuberia_redonda;
